import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

import { CommonService } from '../services/common/common.service'
import { GlobalConstants } from '../constants/global-constants'
import { AuthService } from '../services/auth/auth.service'

@Injectable({ providedIn: 'root' })
export class RouteGuard {
  constructor(private authService: AuthService, private cs: CommonService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const isUserAuthenticated = this.authService.isUserAuthenticated()

    return of(isUserAuthenticated).pipe(
      map(authenticated => {
        if (authenticated) {
          this.cs.routeTo(GlobalConstants.ROUTING.DASHBOARD)
          return true
        }
        return true
      })
    )
  }
}
